import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, useEffect, useState } from 'react';

import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { useLibraryData } from '../plans/use-library-data';
import styles from './library-switch.module.css';

type Props = {
    value: string | SubscriptionPackage.LibraryEnum
    onChange: (value: SubscriptionPackage.LibraryEnum) => void
};

export const LibrarySwitch: FC<Props> = ({ value, onChange }) => {
    const [isOpen, setOpen] = useState(false);
    const { options } = useLibraryData();

    useEffect(() => {
        setOpen(false);
    }, [value]);

    const toggleOpen = () => setOpen((v) => !v);

    return (
        <span className={styles['switch__container']}>
            <button onClick={toggleOpen} tabIndex={-1} className={styles['switch__label']} type="button">
                Select Library:
            </button>
            <span className={styles['items__container']}>
                <button
                    onClick={toggleOpen}
                    type="button"
                    className={classNames(styles['switch__toggle'], {
                        [styles['switch__toggle--open']]: isOpen
                    })}>
                    {options.find((o) => o.id === value)?.title}
                </button>

                {isOpen && (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
                    <div onClick={toggleOpen} role="button" className={styles['items__backdrop']} aria-label="Close" />
                )}

                <AnimatePresence>
                    {isOpen && (
                        <motion.ul
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{
                                opacity: 1,
                                scale: 1,
                                transition: {
                                    type: 'tween',
                                    duration: 0.2,
                                    ease: 'circOut'
                                }
                            }}
                            exit={{
                                opacity: 0,
                                scale: 0.8,
                                transition: {
                                    type: 'tween',
                                    duration: 0.2,
                                    ease: 'circIn'
                                }
                            }}
                            className={styles['items__list']}
                        >
                            {options.map((item) => (
                                <li className={styles['items__item']} key={item.id}>
                                    <label>
                                        <input className={styles['items__radio']} onChange={(evt) => onChange(evt.target.value as unknown as SubscriptionPackage.LibraryEnum)} type="radio" name="library" value={item.id} />
                                        <span className={classNames(styles['items__label'], {
                                            [styles['items__label--active']]: item.id === value
                                        })}>
                                            {item.title}
                                        </span>
                                    </label>
                                </li>
                            ))}
                        </motion.ul>
                    )}
                </AnimatePresence>
            </span>
        </span>
    );
};
